import { TemplateTriviaQuestions } from "./Templates";
import { minutes, miliSeconds } from './CalcTime';

const ResumeAnswersTest = (asnwers)=>{
    const triviaQuestions = document.querySelector('#trivia-test');
    const triviaResume = document.querySelector('#trivia-resume-test');
    const triviaResumeCtn = document.querySelector('#trivia-resume-render-test');
    const triviaTotalTime = document.querySelector('#total-time');
    const triviaCorrectAnswers = document.querySelector('#corrects-answers');
    //Validate if answers exis
    triviaQuestions.classList.add('hidden-important');
    triviaResume.classList.remove('hidden');
    //Render resume
    const { data, max_questions, totalcorrect, totaltime } = asnwers;
    console.log(data);
    //Set resume texts
    let segundos = miliSeconds(totaltime);
    triviaCorrectAnswers.textContent = `${totalcorrect}/${max_questions}`;
    triviaTotalTime.textContent = minutes(segundos);
    //Render answers
    data.forEach((answer, indice)=>{
        const { id, pregunta, respuesta1, respuesta2, respuesta3, respuesta4, ans, correct, respuesta_correcta } = answer;
        const template = TemplateTriviaQuestions(indice, id, pregunta, respuesta1, respuesta2, respuesta3, respuesta4, 'active', ans, correct, respuesta_correcta);
        triviaResumeCtn.append(template);
    });

}

export { ResumeAnswersTest }